import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { BenchmarkingTabCodes } from './BenchmarkingNavigation';
import { LatestSurveyProgress } from './latest-survey-progress';
import { PackUsage } from './PackUsage';
import { SubmissionInsights } from './submission-insights';
import './styles.scss';

interface Params {
  page?: string;
  portfolioId: string;
}

const BenchmarkingComponent = ({ page, portfolioId }: Params) => {
  switch (page) {
    case BenchmarkingTabCodes.PackUsage:
      return <PackUsage />;
    case BenchmarkingTabCodes.SubmissionInsights:
      return <SubmissionInsights />;
    default:
    case BenchmarkingTabCodes.LatestSurveyProgress:
      return <LatestSurveyProgress portfolioId={portfolioId} />;
  }
};

export const Benchmarking = () => {
  const { path } = useRouteMatch();
  const { page, portfolioId } = useParams<Params>();
  return (
    <Switch>
      <Route path={path}>
        <BenchmarkingComponent page={page} portfolioId={portfolioId} />
      </Route>
    </Switch>
  );
};
